<template>
  <div v-if="this.user == 'poonsak.ngk'">
    <div class="header">
      <vs-row>
        <h1 style="color: #003e9b">Map</h1>
      </vs-row>
      <br />
    </div>
    <div class="container">
      <div class="row">
        <div class="div1">
          <template>
            <img
              v-if="!mapimg"
              src="../../../assets/images/map.png"
              width="95%"
              height="400px"
              style="overflow-x: auto; overflow-y: auto"
            />
            <img
              v-else
              :src="mapimg"
              width="95%"
              height="400px"
              style="overflow-x: auto; overflow-y: auto"
            />
            <div v-if="active == true">
              <div v-for="(itemdata, index) in sensorlist" :key="index">
                <div v-for="(item, i) in itemdata" :key="i">
                  <vue-draggable-resizable
                    v-if="item.value == false"
                    :x="item.x * width"
                    :y="item.y * height"
                    :resizable="false"
                    @dragstop="(left, top) => onDragging(item, left, top)"
                    :w="80"
                    :h="40"
                    style="background-color: grey"
                  >
                    <p>
                      <b
                        >{{ item.rack }}
                        <div v-if="item.value == false">OFF</div>
                        <div v-else>ON</div></b
                      >
                    </p>
                  </vue-draggable-resizable>
                  <vue-draggable-resizable
                    v-else
                    :resizable="false"
                    :x="item.x * width"
                    :y="item.y * height"
                    @dragstop="(left, top) => onDragging(item, left, top)"
                    :w="80"
                    :h="40"
                    style="background-color: #5fa74b"
                  >
                    <p>
                      <b
                        >{{ item.rack }}
                        <div v-if="item.value == false">OFF</div>
                        <div v-else>ON</div></b
                      >
                    </p>
                  </vue-draggable-resizable>
                </div>
              </div>
            </div>
          </template>
        </div>
        <div class="div2">
          <div style="position: fixed">
            <vs-tabs>
              <vs-tab label="Map">
                <div class="con-tab-ejemplo">
                  <br />
                  <!-- <vs-button type="filled">Add New Map</vs-button>
                  <br><br> -->
                  <vs-collapse-item>
                    <div slot="header">NGK Map</div>
                    <div class="centerx">
                      <vs-button
                        color="#147efb"
                        type="line"
                        @click="mapchange('1')"
                        >Show Map</vs-button
                      ><br />
                      <vs-button
                        color="#147efb"
                        type="line"
                        @click="importsensor"
                        >Import Sensor</vs-button
                      ><br />
                      <vs-button color="#147efb" type="line" @click="savesensor"
                        >Save</vs-button
                      >
                    </div>
                    <br /><br />
                  </vs-collapse-item>
                  <!-- <vs-collapse-item>
                    <div slot="header">
                      Location B
                    </div>
                    <vs-button  color="#fd9426" type="line" @click="mapchange('4')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Location B : Room 1&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</vs-button><br>
                    <vs-button  color="#fd9426" type="line" @click="mapchange('5')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Location B : Room 2&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</vs-button><br>
                    <vs-button  color="#fd9426" type="line" @click="mapchange('6')">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Location B : Room 3&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</vs-button>
                    <br><br>
                  </vs-collapse-item> -->
                </div>
              </vs-tab>
              <vs-tab label="Upload File">
                Upload file To:
                <vs-select
                  class="selectExample"
                  autocomplete
                  v-model="selected"
                >
                  <div :key="index" v-for="(item, index) in maplist">
                    <vs-select-group :title="item.title" v-if="item.group">
                      <vs-select-item
                        :key="index"
                        :value="item.value"
                        :text="item.text"
                        v-for="(item, index) in item.group"
                      />
                    </vs-select-group>
                  </div> </vs-select
                ><br />
                <input
                  type="file"
                  ref="file"
                  accept="image/*"
                  @change="FileSelect"
                /><br /><br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <vs-button
                  class="fields center"
                  color="primary"
                  type="border"
                  @click="Upload"
                  >Submit</vs-button
                >
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <!-- <vs-button v-if="mapimg"
      class="mb-2 hiddenDesktop"
      style="border-radius: 30px; "
      color="warning"
      type="filled"
      icon="reply"
      @click="refw()"
     >back</vs-button
   > -->

    <vs-row v-if="mapimg" vs-w="12">
      <vs-col
        style="display: flex; align-items: center"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <!-- <vs-button class="mr-2 hiddenDesktop" @click="refw()" radius color="#ffffff" type="flat" >
            <span><vs-icon icon="reply_all" size="20px" color="success"></vs-icon></span></vs-button>
          <h4 style="width: 400px"> Map : {{itemname}}</h4>  -->

        <div id="show" class="w3-hide-medium w3-hide-large">
          <br /><br />
          <vs-row>
            <vs-col
              vs-offset="4"
              v-tooltip="'col - 4'"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="4"
            >
              <span>
                <vs-icon
                  icon="screen_rotation"
                  size="105px"
                  color="success"
                ></vs-icon>
              </span>
            </vs-col>
            <vs-col
              class="mt-4"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <h3>Please rotate your device</h3>
            </vs-col>
            <vs-col
              class="mt-2"
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-w="12"
            >
              <h5>We support portrait mode only</h5>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>

    <vs-row v-if="mapimg" class="w3-hide-small" vs-w="12">
      <vs-col
        style="display: flex; align-items: center"
        vs-type="flex"
        vs-justify="center"
        vs-align="center"
        vs-lg="12"
        vs-sm="12"
        vs-xs="12"
      >
        <vs-button
          class="mr-2 hiddenDesktop"
          @click="refreshPage()"
          radius
          color="#ffffff"
          type="flat"
        >
          <span
            ><vs-icon
              icon="reply_all"
              size="20px"
              color="success"
            ></vs-icon></span
        ></vs-button>
        <h4 style="width: 400px">Map : {{ itemname }}</h4>
        <!-- Website -->
        <vs-row v-if="btn == true">
          <vs-spacer />
          <vs-button
            class="mr-2 w3-hide-small brdbtn"
            color="dark"
            v-b-modal.modal-xl
            type="flat"
            icon="add"
            >Manage Sensor</vs-button
          >
          <vs-button
            class="mr-2 w3-hide-small brdbtn"
            color="dark"
            v-if="showbtn == '1'"
            @click="
              importsensor(itemid),
                (ddactive2 = 'false'),
                (showbtn = '2'),
                (drag = true)
            "
            type="flat"
            icon="drag_indicator"
            >Show Sensor</vs-button
          >
          <vs-button
            class="mr-2 w3-hide-small brdbtn"
            color="dark"
            v-if="showbtn == '2'"
            @click="
              loadsensor(itemid),
                (ddactive = 'false'),
                (showbtn = '1'),
                (drag = true)
            "
            type="flat"
            icon="speaker_notes"
            >Load Data</vs-button
          >
          <vs-tooltip text="Upload File">
            <vs-button
              radius
              class="mr-2 w3-hide-small w3-hide-medium"
              color="dark"
              v-b-modal.modal-Upload
              type="line"
            >
              <span
                ><vs-icon
                  icon="cloud_upload"
                  size="20px"
                  color="dark"
                ></vs-icon></span
            ></vs-button>
          </vs-tooltip>
          <vs-tooltip text="Save Sensor">
            <vs-button
              color="success"
              class="mr-1"
              style="border-radius: 20px"
              size="sm"
              v-b-modal.savesensor
              type="filled"
              >Save Map</vs-button
            >
          </vs-tooltip>
          <vs-button
            color="dark"
            class="mr-1"
            style="border-radius: 17px"
            size="sm"
            @click="cancelMap"
            type="flat"
            >Cancel</vs-button
          >
        </vs-row>
        <!-- Responsive -->
        <vs-row v-if="btn == false">
          <vs-spacer />
          <vs-tooltip text="Edit Map">
            <vs-button
              class="mr-2 w3-hide-small w3-hide-medium brdbtn"
              color="dark"
              @click="btn = true"
              type="flat"
              icon="edit"
              >Edit Map</vs-button
            >
          </vs-tooltip>
          <vs-button
            class="mr-2 w3-hide-small"
            color="dark"
            @click="
              importsensor(itemid),
                (ddactive2 = 'false'),
                (showbtn = '2'),
                (drag = false)
            "
            type="flat"
            icon="drag_indicator"
            >Show Sensor</vs-button
          >
          <vs-button
            class="mr-2 w3-hide-small"
            color="dark"
            @click="
              loadsensor(itemid),
                (ddactive = 'false'),
                (showbtn = '1'),
                (drag = false)
            "
            type="flat"
            icon="speaker_notes"
            >Load Data</vs-button
          >

          <!-- <vs-tooltip text="Zoom to Fit ">
            <vs-button class="mr-2 w3-hide-medium w3-hide-small" radius color="dark" type="line"  @click="zoomFix()">
            <span><vs-icon icon="crop_free" size="20px" color="dark"></vs-icon></span></vs-button></vs-tooltip>
          <vs-tooltip text="Full Screen">
              <vs-button class="mr-1 w3-hide-medium w3-hide-small" radius color="dark" type="line"    @click="toggle">
              <span><vs-icon icon="zoom_out_map" size="20px" color="dark"></vs-icon></span></vs-button></vs-tooltip>
               -->
          <!-- <vs-tooltip text="Zoom In">
                  <vs-button class="mr-2" radius color="dark" type="line"  @click="zoomIn()">
                  <span><vs-icon icon="zoom_in" size="20px" color="dark"></vs-icon></span></vs-button></vs-tooltip>
              <vs-tooltip text="Zoom Out">
                  <vs-button class="mr-2" radius color="dark" type="line"  @click="zoomOut()">
                  <span><vs-icon icon="zoom_out" size="20px" color="dark"></vs-icon></span></vs-button></vs-tooltip> -->
          <vs-dropdown
            vs-trigger-click
            left
            class="cursor-pointer w3-hide-large mr-1"
          >
            <a class="text-dark" href="#"
              ><span>
                <vs-icon icon="more_vert" color="dark"></vs-icon> </span
            ></a>
            <vs-dropdown-menu class="topbar-dd">
              <vs-dropdown-item @click="btn = true"
                ><span class="mr-1"><vs-icon icon="edit"></vs-icon></span>Edit
                Map</vs-dropdown-item
              >
              <!-- <vs-dropdown-item @click="importsensor(itemid)"><span class="mr-1"><vs-icon icon="edit"></vs-icon></span>Edit Map</vs-dropdown-item> -->
              <vs-dropdown-item @click="showModalUpload"
                ><span class="mr-1"><vs-icon icon="add"></vs-icon></span>Upload
                File</vs-dropdown-item
              >
              <!-- <vs-dropdown-item @click="zoomFix()"><span class="mr-1"><vs-icon icon="crop_free"></vs-icon></span>Zoom to Fit</vs-dropdown-item>
                              <vs-dropdown-item @click="toggle"><span class="mr-1"><vs-icon icon="zoom_out_map"></vs-icon></span>Full Screen</vs-dropdown-item> -->
            </vs-dropdown-menu>
          </vs-dropdown>
        </vs-row>
      </vs-col>
    </vs-row>
    <b-modal id="modal-xl" ref="modal-xl" scrollable size="xl" centered>
      <template #modal-title>
        <h4><b class="text-primary">Manage Sensor</b></h4>
      </template>
      <!--               
              <vs-row id="center">  <h5 class="mt-2">Filters :</h5>
                    <v-select style="min-width: 300px;" class="mt-2 ml-3" multiple v-model="selectFilter" :options="header" /><vs-spacer />
                    <h5 class="mt-2 mr-2">Search : </h5><vs-input class="mt-2" icon-no-border icon="search" style="border-radius: 20px;"  v-model="value7"/>
              </vs-row> -->

      <h5 class="my-4">List Sensor</h5>
      <div id="wrapper">
        <div v-for="(item, i) in imsensorlist" :key="i">
          <div class="card card-1" v-if="item.mapid == itemid || !item.mapid">
            <a href="#rounded" class="header-anchor mt-1">
              <b-icon font-scale="4" icon="broadcast"></b-icon
            ></a>
            <h6 class="mt-2">{{ item.name }}</h6>
            <vs-row class="mt-3 mb-2"
              ><vs-spacer />
              <vs-button
                type="flat"
                color="danger"
                :disabled="!item.ismapping"
                @click="remove(item)"
              >
                Remove</vs-button
              >
              <vs-button
                style="border-radius: 20px; width: 50%"
                size="sm"
                type="filled"
                :disabled="item.ismapping"
                @click="add(item)"
                ><vs-icon icon="add" /> Add</vs-button
              ></vs-row
            >
          </div>
          <div class="card card-2" v-else>
            <a href="#rounded" class="header-anchor text-warning mt-1">
              <b-icon font-scale="4" icon="broadcast"></b-icon
            ></a>
            <h6 class="mt-2">{{ item.name }}</h6>
            <vs-row class="mt-3 mb-2"
              ><vs-spacer />
              <vs-button
                type="flat"
                color="danger"
                :disabled="true"
                @click="remove(item)"
              >
                Remove</vs-button
              >
              <vs-button
                style="border-radius: 20px; width: 50%"
                size="sm"
                type="filled"
                color="success"
                :disabled="true"
                @click="add(item)"
                ><vs-icon icon="add" /> Add</vs-button
              >
            </vs-row>
          </div>
        </div>
      </div>

      <!-- <vs-row>
                <vs-col  vs-type="flex" vs-justify="center"  vs-lg="4" vs-sm="12" vs-xs="12" v-for="(item,i) in imsensorlist" :key="i">
                  <vs-card class="rou" v-if="item.mapid == itemid || !item.mapid">
                   <vs-row class="mt-1 container">
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="3">
                     <a href="#rounded" class="header-anchor "> <b-icon font-scale="4" icon="broadcast"></b-icon></a>
                      </vs-col> 
                       <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="7" vs-xs="8">
                        <b><h6 >{{item.name}}</h6></b>
                      </vs-col>
                   </vs-row>
                     <vs-row class="mt-2"><vs-spacer />
                    <vs-button type="flat"  color="danger" :disabled="!item.ismapping" @click="remove(item)"> Remove</vs-button>
                    <vs-button style="border-radius: 20px; width: 80px;" size="sm" type="filled" :disabled="item.ismapping" @click="add(item)"><vs-icon icon="add" /> Add</vs-button></vs-row>
                  </vs-card>

                  <vs-card  class="rou  " v-else>
                    
                    <vs-row class="mt-1 container">
                      <vs-col vs-type="flex" vs-justify="center" vs-align="center" vs-lg="3" vs-sm="4" vs-xs="3">
                       <a href="#rounded" class="header-anchor text-warning "> <b-icon font-scale="4" icon="broadcast"></b-icon></a> 
                      </vs-col>
                      <vs-col  vs-type="flex" vs-justify="center" vs-align="center" vs-lg="8" vs-sm="7" vs-xs="8">
                        <b><h6 >{{item.name}}  <a style="font-size: 7px;" class=" text-danger">
                          <br>(This sensor is in another map)</a></h6></b>
                      </vs-col>
                    </vs-row>
                    <vs-row class="mt-2"><vs-spacer />
                     <vs-button  type="flat" color="danger" :disabled="true" @click="remove(item)"> Remove</vs-button>
                    <vs-button style="border-radius: 20px; width: 80px;" size="sm" type="filled"  color="success" :disabled="true" @click="add(item)"><vs-icon icon="add" /> Add</vs-button>
                   
                    </vs-row> 
                  </vs-card>
                </vs-col>
              </vs-row> -->
      <template #modal-footer="{ cancel }">
        <!-- Button with custom close trigger value -->
        <vs-button
          color="success"
          style="border-radius: 20px; width: 80px"
          size="sm"
          type="filled"
          @click="saveImageSensor()"
          >Save</vs-button
        >
        <vs-button
          class="brdbtn"
          color="dark"
          style="width: 80px"
          type="flat"
          @click="cancel()"
          >Cancel</vs-button
        >
      </template>
    </b-modal>
    <!-- <vs-card v-if="ddactive == true" class="rou">
  <h5 class="ml-2 mt-2">Sensor List</h5>
<div  class="flex-container">
  <div class="flex-item" :key="index" v-for="(item,index) in sensorlist">
    <vue-draggable-resizable style="border-style: none;"  class="flex-item"   :x="(item.x*width)" :y="(item.y*height)" :draggable="true" :resizable="false" @dragstop="(left, top) => onDragging(item, left, top)" :w="200" :h="item.h" >
   <vs-tooltip text="Tooltip Default">
     <vs-icon icon="room" size="40px" color="#BC1254"></vs-icon>
     <vs-row v-for="(data,i) in Object.keys(item)" :key="i">
      <p v-if="data != 'x' && data != 'y' && data != 'h'"  style="padding: 1%; color: black;">{{data}}</p>
    </vs-row></vs-tooltip>
</vue-draggable-resizable>

  </div>

  
</div></vs-card><br> -->
<div class="w3-hide-small"  v-if="drag == true">
<div v-if="ddactive == true">
  <div   v-for="(item,index) in sensorlist" :key="index">
    <vue-draggable-resizable  style="border-style: none;" :x="(item.x*width)" :y="(item.y*height)" :draggable="drag" :resizable="false" @dragstop="(left, top) => onDragging(item, left, top)" :w="200" :h="item.h">
    <vs-tooltip
      :title="sensordetail[index].name"
      color="#676767"
      :text="sensordetail[index].data">
      <div>
        <vs-col  vs-type="flex" class="danger " vs-justify="center" vs-align="center">
           <vs-button id="sensorl" v-on:dblclick="counter += 1, toSensorDashboard(sensordetail[index].sid)" type="flat">
               <span>
                 <!-- <vs-icon :icon="sss[index]"   size="50px" color="#ffff"></vs-icon> -->
                 <vs-icon icon="room" size="40px" color="#FF0000"></vs-icon>
              </span>
            </vs-button>
        </vs-col>
        <!-- <v-bar wrapper="wrapper"> -->
        <b-list-group
          class="hiddenDesktop"
          v-for="(item, i) in maplist"
          :key="i"
        >
          <b-list-group-item
            v-if="item.name == itemname"
            class="itemactive"
            id="btnlist"
            button
            @click="
              mapchange(item.id),
                (itemname = item.name),
                (itemid = item.id),
                show(item)
            "
          >
            <vs-row id="linecenter">
              <b-icon icon="cursor" class="mr-2 rounded-circle"></b-icon>
              <h6 id="btna">{{ item.name }}</h6>
              <vs-spacer />
            </vs-row>
          </b-list-group-item>
          <b-list-group-item
            v-if="item.name != itemname"
            id="btnlist"
            button
            @click="
              mapchange(item.id),
                (itemname = item.name),
                (itemid = item.id),
                show(item)
            "
          >
            <vs-row id="linecenter">
              <b-icon icon="cursor" class="mr-2 rounded-circle"></b-icon>
              <h6 id="btna">{{ item.name }}</h6>
              <vs-spacer />
            </vs-row>
          </b-list-group-item>
        </b-list-group>
        <br />
      </div>
    </vs-tooltip>
    </vue-draggable-resizable>
    </div>
  </div>
  
</div>
 <div v-if="ddactive2 == true">
  <div  v-for="(item,index) in sensorlist" :key="index">
    <vue-draggable-resizable style="border-style: none;" :x="(item.x*width)" :y="(item.y*height)" :draggable="drag" :resizable="false" @dragstop="(left, top) => onDragging(item, left, top)" :w="200" :h="item.h">
    <vs-tooltip class="text-dark"
      :title="sensordetail[index].name"
      color="#676767">
      <vs-button id="sensorl" color="light"  v-on:dblclick="counter += 1, toSensorDashboard(sensordetail[index].sid)" type="filled">
          <span>
            <vs-icon icon="filter_list"   id="iconMap" color="#111111"></vs-icon>
        </span>
     <vs-collapse v-if="data != 'x' && data != 'y' && data != 'h'"  style="padding: 1%; color: black;">
     <vs-collapse-item  icon-arrow="arrow_drop_down">
       <div slot="header">
          <h5 id="datatext"> {{sensordetail[index].name}}</h5> 
       </div>
          <h5 id="datatext" v-for="(text,i) in Object.keys(sensordetail[index].data)" :key="i">{{text}}: {{sensordetail[index].data[text]}}</h5>
       </vs-collapse-item></vs-collapse> 
      </vs-button>  </vs-tooltip>
    </vue-draggable-resizable>
  </div>
</div>
<div v-if="mapimg" class="mt-3" id="sampleDiv" style="width: 100%;   margin: auto; text-align: center;      ">
  <!-- <v-zoomer> -->
    <img id="sky" :src="mapimg" 
      width="65%" 
      align="middle"
      class="center example">
  <!-- </v-zoomer> -->
</div>
<div class="w3-hide-small" v-else>
<div v-if="mapimg" class="mt-3" id="sampleDiv" style="width: 100%;   margin: auto; text-align: center;      ">
  <v-zoomer :doubleClickToZoom="false">
<div v-if="ddactive == true">
  <div   v-for="(item,index) in sensorlist" :key="index">
    <vue-draggable-resizable  style="border-style: none;" :x="(item.x*width)" :y="(item.y*height)" :draggable="drag" :resizable="false" @dragstop="(left, top) => onDragging(item, left, top)" :w="200" :h="item.h">
    <vs-tooltip
      :title="sensordetail[index].name"
      color="#676767"
      :text="sensordetail[index].data">
      <div>
        <vs-col  vs-type="flex" class="danger " vs-justify="center" vs-align="center">
           <vs-button id="sensorl" v-on:dblclick="counter += 1, toSensorDashboard(sensordetail[index].sid)"  type="flat">
               <span>
                 <!-- <vs-icon :icon="sss[index]"   size="50px" color="#ffff"></vs-icon> -->
                 <vs-icon icon="room" size="40px" color="#FF0000"></vs-icon>
              </span>
           </vs-button>
          </vs-col>
      </div>
    </vs-tooltip>
    <div style="display: none;"  v-for="(data,i) in Object.keys(item)" :key="i">
      <span v-if="data != 'x' && data != 'y' && data != 'h'"  style="padding: 1%">{{data}}: {{item[data]}}</span>
    </div>
    </vue-draggable-resizable>
  </div>
  
</div>
 <div v-if="ddactive2 == true">
  <div  v-for="(item,index) in sensorlist" :key="index">
    <vue-draggable-resizable style="border-style: none;" :x="(item.x*width)" :y="(item.y*height)" :draggable="drag" :resizable="false" @dragstop="(left, top) => onDragging(item, left, top)" :w="200" :h="item.h">
    <vs-tooltip class="text-dark"
      :title="sensordetail[index].name"
      color="#676767">
      <vs-button id="sensorl" color="light"  v-on:dblclick="counter += 1, toSensorDashboard(sensordetail[index].sid)" type="filled">
          <span>
            <vs-icon icon="filter_list"   id="iconMap" color="success"></vs-icon>
        </span>
  <vs-collapse v-if="data != 'x' && data != 'y' && data != 'h'"  style="padding: 1%;  color: black;">
     <vs-collapse-item  icon-arrow="expand_more">
       <div slot="header">
          <h5 id="datatext">{{sensordetail[index].name}}</h5>
       </div>
          <h5 id="datatext" v-for="(text,i) in Object.keys(sensordetail[index].data)" :key="i">{{text}}: {{sensordetail[index].data[text]}}</h5>
       </vs-collapse-item></vs-collapse>
      </vs-button>
    </vs-tooltip>
    </vue-draggable-resizable>
  </div>
</div>
    <img id="sky" :src="mapimg" 
      width="65%" height="80%"
      align="middle"
      class="center example">
  </v-zoomer>
</div>
<div  class="hiddenDesktop" v-else id="responsiveSidebar">
    <h4>  
      <vs-list-item title="Map ">
        <vs-button  color="success"  v-b-modal.addsensor icon="add"  id="btnbackover">
            <h6>Add New Map</h6> 
        </vs-button>
      </vs-list-item></h4>
  <!-- <v-bar wrapper="wrapper"> -->
  <b-list-group class=" hiddenDesktop" v-for="(item,i) in maplist" :key="i">
    <b-list-group-item  v-if="item.name==itemname"  class="itemactive" id="btnlist" button @click="mapchange(item.id),itemname=item.name,itemid=item.id,show(item)">
      <vs-row   id="linecenter">
        <b-icon icon="cursor"  class="mr-2 rounded-circle "></b-icon>
        <h6 id="btna"> {{ item.name }}</h6><vs-spacer />
      </vs-row>
    </b-list-group-item>
    <b-list-group-item  v-if="item.name!=itemname"   id="btnlist" button @click="mapchange(item.id),itemname=item.name,itemid=item.id,show(item)">
      <vs-row   id="linecenter">
        <b-icon icon="cursor"  class="mr-2 rounded-circle "></b-icon>
        <h6 id="btna"> {{ item.name }}</h6><vs-spacer />
      </vs-row>
    </b-list-group-item>
  </b-list-group>
  <br>
</div>
</div>
  
      <!-- </v-bar> -->
   <b-modal id="modal-Upload" ref="my-modal" centered hide-footer title="Upload file">
      Upload file To : {{ itemname }} 
      <br>
              <input
                type="file"
                ref="file"
                class="mt-4"
                accept="image/*"
                @change="FileSelect"
              /><br><br>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <!-- <vs-button class="fields center" color="primary" type="border" @click="Upload">Submit</vs-button> -->
                <vs-row class="ml-3 mt-3" vs-w="12">
 <vs-spacer />
   <vs-button type="filled" size="sm" style="border-radius: 20px;" color="success"  @click="Upload">Upload file</vs-button>
 
 <b-button class="ml-2 mr-4" id="btncancel"  variant="light" @click="closeUpload()">
        Cancel
      </b-button>
 
</vs-row>
  </b-modal>
        
      <!-- <template>
       
            <img v-if="!mapimg" src="../../../assets/images/map.png"   style="width:100%" />
            <img v-else :src="mapimg"  style="width:100%" />
            <div v-if="active == true">
              <div v-for="(itemdata,index) in sensorlist" :key="index">
                <div v-for="(item,i) in itemdata" :key="i">
                  <vue-draggable-resizable v-if="item.value == false" :draggable="user == 'poonsak.ngk'" :x="(item.x*width)" :y="(item.y*height)" :resizable="false" @dragstop="(left, top) => onDragging(item, left, top)" :w="80" :h="40"
                  style="background-color: grey">
                    <p><b>{{item.rack}} 
                    <div v-if="item.value == false">OFF</div>
                    <div v-else>ON</div></b></p>
                  </vue-draggable-resizable>
                  <vue-draggable-resizable v-else :resizable="false" :draggable="user == 'poonsak.ngk'" :x="(item.x*width)" :y="(item.y*height)" @dragstop="(left, top) => onDragging(item, left, top)" :w="80" :h="40"
                    style="background-color: #5fa74b">
                    <p><b>{{item.rack}} 
                    <div v-if="item.value == false">OFF</div>
                    <div v-else>ON</div></b></p>
                  </vue-draggable-resizable>
                </div>
              </div>
            </div>
          </template> -->

    <b-modal id="savesensor" v-model="modalShow" centered>
      <template #modal-title>
        <b class="text-primary">Save Map</b>
      </template>
      <p class="my-4">Do you want to save map?</p>

      <template #modal-footer="{ cancel }">
        <!-- Button with custom close trigger value -->
        <vs-button
          color="success"
          style="border-radius: 20px"
          size="sm"
          @click="savesensor(itemid)"
          type="filled"
          >Save Map</vs-button
        >
        <b-button id="btncancel" variant="light" @click="cancel()">
          Cancel
        </b-button>
      </template>
    </b-modal>

    <!-- Modal Add sensor -->
    <b-modal
      id="addsensor"
      ref="addsensor"
      no-close-on-backdrop="false"
      hide-header-close
      centered
      size="lg"
    >
      <template #modal-title>
        <h4 style="color: #32c040">Add New Map</h4>
      </template>
      <div>
        <vs-row class="mb-1" vs-w="12">
          <vs-col
            class="mt-2 mb-1"
            vs-type="flex"
            vs-align="center"
            vs-lg="8"
            vs-sm="12"
            vs-xs="12"
          >
            <h6>Map Name :</h6>
            <vs-input
              class="ml-2"
              style="width: 330px"
              v-model="newmapname"
              placeholder="New Map Name"
            />
          </vs-col>
        </vs-row>
        <vs-row class="mb-1" vs-w="12">
          <vs-col
            class="mt-3 mb-1"
            vs-type="flex"
            vs-lg="8"
            vs-sm="12"
            vs-xs="12"
          >
            <h6 class="mt-3">Upload file :</h6>
            <vs-input
              class="ml-2"
              style="width: 330px"
              type="file"
              description-text="Supported file extensions : .jpg , .jpeg , .png "
              ref="file"
              accept="image/*"
              @change="FileSelect"
            />
          </vs-col>
        </vs-row>
      </div>
      <template #modal-footer="{}">
        <vs-button class="bts" color="success" @click="addNewMap" type="filled"
          >Add</vs-button
        >
        <b-button
          class="ml-1"
          id="btncancel"
          variant="light"
          @click="cancel1()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>

    <vs-prompt
      color="success"
      title="Add New Map"
      type="alert"
      @accept="addNewMap"
      :active.sync="active"
    >
      <vs-input label="Map Name" v-model="newmapname" /><br />
      Upload file :

      <input
        class="ml-2"
        type="file"
        ref="file"
        accept="image/*"
        @change="FileSelect"
      />
    </vs-prompt>

    <!-- side bar -->
    <div class="parentx-static">
      <vs-sidebar
        static-position
        default-index="2"
        v-model="active2"
        color="primary"
        spacer
        class="sidebarx w3-hide-small w3-hide-medium"
      >
        <vs-row class="mt-1 mb-1" style="display: flex; align-items: center">
          <vs-list-item icon="room" title="Map"> </vs-list-item>
          <vs-spacer />
          <vs-button
            class="hiddenDesktop cursor-pointer"
            color="danger"
            icon="close"
            size="large"
            @click="swap"
            type="flat"
          ></vs-button>
        </vs-row>

        <vs-button
          class="primary mt-2"
          to="/Overview"
          icon="reply"
          type="filled"
          id="btnbackover"
        >
          <h6>Back to Overview</h6>
        </vs-button>
        <vs-button
          class="primary mt-2 mb-3"
          v-b-modal.addsensor
          icon="add"
          type="border"
          id="btnbackover"
        >
          <h6>Add New Map</h6>
        </vs-button>
        <!-- <vs-button  class="primary mt-2 mb-3"  @click="active = true" icon="add" type="border" id="btnbackover">
     <h6>Add New Map1</h6> 
        </vs-button> -->
        <br />

        <h6 id="mapl" class="mb-3 mt-3 ml-1"><b>Map List</b></h6>

        <div>
          <!-- <v-bar wrapper="wrapper"> -->
          <b-list-group v-for="(item, i) in maplist" :key="i">
            <b-list-group-item
              v-if="item.name == itemname"
              class="itemactive"
              id="btnlist"
              button
              @click="
                mapchange(item.id),
                  (itemname = item.name),
                  (itemid = item.id),
                  show(item)
              "
            >
              <vs-row id="linecenter">
                <b-icon icon="cursor" class="mr-2 rounded-circle"></b-icon>
                <h6 id="btna">{{ item.name }}</h6>
                <vs-spacer />
              </vs-row>
            </b-list-group-item>
            <b-list-group-item
              v-if="item.name != itemname"
              id="btnlist"
              button
              @click="
                mapchange(item.id),
                  (itemname = item.name),
                  (itemid = item.id),
                  show(item)
              "
            >
              <vs-row id="linecenter">
                <b-icon icon="cursor" class="mr-2 rounded-circle"></b-icon>
                <h6 id="btna">{{ item.name }}</h6>
                <vs-spacer />
              </vs-row>
            </b-list-group-item>
          </b-list-group>
          <br />
          <!-- </v-bar> -->
        </div>
      </vs-sidebar>
    </div>
  </div>
</template>

<script>
import "viewerjs/dist/viewer.css";
import { Draggable } from "draggable-vue-directive";
import VBar from "v-bar";
import MD from "../dashboard/Map/MapDashboard.vue";
import Fullscreen from "vue-fullscreen/src/component.vue";

export default {
  // components: { VBar ,Fullscreen},
  directives: {
    Draggable,
  },
  name: "Map",
  data: () => ({
    drag: false,
    activeBtn: "",
    fullscreen: false,
    btna: "",
    btn: false,
    myImg: "",
    currWidth: "",
    selec: "",
    counter: 0,
    currHeight: "",
    element: "",

    activeColor: "red",
    fontSize: 30,
    isActive: true,
    error: null,
    showCreditCard: true,
    letbtn: "",
    sss: ["email", "filter_list", "filter_list"],
    btnzoom: [1, 2, 3],
    active: false,
    active2: false,
    ddactive: false,
    showbtn: "1",
    ddactive2: false,
    sid: [],
    aaa: "dkodkodkco",
    handleId: "handle-id",
    draggableValue: {
      handle: undefined,
    },
    file: "",
    img: "",
    modalShow: false,
    mapres: true,
    itemid: "",
    itemname: "",
    selected: "",
    maplist: [],
    mapimg: "",
    newmapname: "",
    mapimgdata: [],
    sensorlist: [],
    sensordetail: [],
    width: '',
    height: '',
    user: '',
    aaa: '',
    imsensorlist:[],
    zoom: 1,
    // maplist: [
    //   {
    //       title:'Location A',
    //       group:[
    //         {text: 'Room 1', value: '1'},
    //         {text: 'Room 2', value: '2'},
    //         {text: 'Room 3', value: '3'}
    //       ]
    //     },
    //     {
    //       title:'Location B',
    //       group:[
    //         {text: 'Room 1', value: '4'},
    //         {text: 'Room 2', value: '5'},
    //         {text: 'Room 3', value: '6'},
    //       ]
    //     }]
  }),
  methods: {
    cancelMap() {
      this.btn = false;
    },
    add(item) {
      item.ismapping = true;
      // console.log(item)
    },
    remove(item) {
      item.ismapping = false;
      // console.log(item)
    },
    loadImageSensor() {
      this.sid = [];
      this.$http
        .get(this.$url + "sensorposlist/" + this.$session.get("token"))
        .then((result) => {
          this.imsensorlist = result.data;
          result.data.forEach((element) => {
            this.sid.push(element.serial_id);
          });
          // console.log(this.imsensorlist)
        });
    },
    saveImageSensor() {
      for (let i = 0; i < this.imsensorlist.length; i++) {
        if (
          this.itemid != this.imsensorlist[i].mapid &&
          this.imsensorlist[i].mapid != null
        ) {
          this.imsensorlist.splice(i, 1);
          i--;
        }
      }
      // console.log(this.imsensorlist)
      // this.imsensorlist.forEach(element => {
      //   if(this.itemid != element.mapid || element.mapid == null) {
      //     this.imsensorlist.splice()
      //   }
      // });
      console.log(this.imsensorlist)
      this.$http.post(this.$url+'sensorposlist', {
        token: this.$session.get('token'),
        sensorlist: this.imsensorlist,
        mapid: this.itemid.toString()
      }).then(() => {
        this.$bvModal.hide('modal-xl')
        this.$vs.notify({
          title: 'Save Sensor',
          text: 'Conplete!',
          color: 'primary'
        });
      }).catch(() => {

      })
    },
    openmodalupload() {
      // console.log("aaaaaa")
      this.$bvModal.show(modal - Upload);
    },
    showModalImage() {
      // this.$bvModal.show(modal-xl)
      this.$refs["modal-xl"].show();
    },
    toSensorDashboard(item) {
      this.$http.get(this.$url+'sensorinfo2/'+item+'/'+this.$session.get('token'))
      .then((result) => {
        this.$session.set('nwname', result.data[0].network)
        this.$session.set('nwid', result.data[0].nwid)
        this.$session.set('sensorname', result.data[0].name)
        this.$session.set('sensorid', result.data[0].serial_id)
        this.$session.set('gatewayid', result.data[0].gatewayid)
        this.$session.set('type', result.data[0].type)
        this.$session.set('lora', result.data[0].lora)
        this.$router.push('/sensordashboard')
      })
    },
    //  toSensorDashboard: function(){
    //    // console.log(aaa)

    //   alert("Sou uma toSensorDashboard");
    //   this.currentSe
    //   this.$session.set('lora', item.lora)
    //   // console.log(this.network,item)
    //   this.$router.push({
    //     name: 'SensorDashboard',
    //     params: {
    //       nwname: this.network,
    //       nwid: item.nwid,
    //       sensorid: item.serial_id,
    //       gatewayid: item.gatewayid,
    //       type: item.type
    //     }
    //   })
    //   //  this.$router.push('/sensordashboard')
    // },
    zoomIn() {
      this.myImg = document.getElementById("sky");
      this.currWidth = this.myImg.clientWidth;
      this.currHeight = this.myImg.clientHeight;
      if (this.currWidth == 3000) {
        alert("Maximum zoom-in level reached.");
      } else {
        this.myImg.style.width = this.currWidth + 50 + "px";
        this.myImg.style.height = this.currHeight + 50 + "px";
      }
    },
    zoomOut() {
      this.myImg = document.getElementById("sky");
      this.currWidth = this.myImg.clientWidth;
      this.currHeight = this.myImg.clientHeight;
      if (this.currWidth == 50) {
        alert("Maximum zoom-out level reached.");
      } else {
        this.myImg.style.width = this.currWidth - 50 + "px";
        this.myImg.style.height = this.currHeight - 50 + "px";
      }
    },
    zoomFix() {
      this.myImg = document.getElementById("sky");
      this.currWidth = this.myImg.clientWidth;
      this.myImg.style.width = 75 + "%";
      this.myImg.style.height = 75 + "%";
    },
    toggle() {
      this.$fullscreen.toggle(this.$el.querySelector(".example"), {
        wrap: false,
        callback: this.fullScreenChange,
      });
    },
    fullScreenChange(fullscreen) {
      this.fullscreen = fullscreen;
    },
    cancel1() {
      this.$refs["addsensor"].hide();
      this.newmapname = "";
      this.file = "";
    },
    cancelHide() {
      this.$refs["my-modal"].hide();
    },
    showModalUpload() {
      this.$refs["my-modal"].show();
    },
    show() {
      // console.log(this.buttons)
    },
    testdata() {
      // console.log('kkkkk')
    },
    swap() {
      // console.log('test')
      this.active2 = !this.active2;
    },
    refreshPage() {
      location.reload();
    },
    addnewmap() {
      // console.log(this.$session.get('token'),this.newmapname)
      this.$http
        .post(this.$url + "map", {
          name: this.newmapname,
          token: this.$session.get("token"),
        })
        .then((result) => {
          // console.log(result.data.id)
          this.itemid = result.data.id;
          this.Upload();
          // location.reload()
        });
    },
    onDragging(item, x, y) {
      if (this.user == "poonsak.ngk") {
        this.sensorlist[0].forEach((element, i) => {
          if (element.rack == item.rack) {
            this.sensorlist[0][i].x = x / window.innerWidth;
            this.sensorlist[0][i].y = y / window.innerHeight;
            // console.log(this.sensorlist[i])
          }
        });
      } else {
        // // console.log(item)
        this.sensorlist.forEach((element, i) => {
          if (element == item) {
            this.sensorlist[i].x = x / window.innerWidth;
            this.sensorlist[i].y = y / window.innerHeight;
            // console.log(this.sensorlist[i])
          }
        });
        // // console.log(window.innerHeight,window.innerWidth,this.sensorlist)
        // console.log(this.sensorlist)
      }
    },
    mapchange(value) {
      this.btn = false
      this.sensordetail = []
      this.sensorlist = []
      this.mapimg = ''
      // console.log(this.btnzoom)
      // document.getElementsByClassName("active");
      // document.getElementById("btnlist").style.color = "red";
      this.maplist.forEach((element) => {
        if (element.id == value) {
          this.$http.get(this.$url + "upload/" + element.img).then((result) => {
            this.mapimg = result.data;
          });
        }
      });
    },
    importsensor(value) {
      this.width = window.innerWidth
      this.height = window.innerHeight
      document.documentElement.style.setProperty('--vw', `${this.width}px`);
      document.documentElement.style.setProperty('--vh', `${this.height}px`);
      var jsonel = ''
      this.sensordetail = []
      this.sensorlist = []
      if(this.user == 'poonsak.ngk') {
        this.$http.get(this.$url+'sensorid/'+this.$session.get('token')).then((result) => {
          result.data.forEach(element => {
            this.sid.push(element.serial_id)
            this.$http.get(this.$url+'sensorpos/'+element.serial_id).then((result2) => {
              result2.data[0].axis.forEach((element,i) => {
                result2.data[0].axis[i] = JSON.parse(result2.data[0].axis[i])
              });
              this.sensorlist.push(result2.data[0].axis)
              this.active = true
              jsonel = JSON.parse(element.lastdata)
              // console.log(jsonel)
              Object.keys(jsonel).forEach(rack => {
                this.sensorlist.forEach((sensor,j) => {
                  sensor.forEach((element,i) => {
                    if(rack == element.rack) {
                      this.sensorlist[j][i].value = jsonel[rack]
                    }
                  }); 
                });
            });
          });
        })
        })
      }else{
      this.$http.get(this.$url+'sensorid/'+this.$session.get('token')).then((result) => {
        // console.log(result.data)
        if(result.data) {   
          result.data.forEach((element,i) => {
            // console.log(i)
            // console.log(element.serial_id,this.$session.get('token'),value)
            this.$http.get(this.$url+'sensorpos/'+element.serial_id+'/'+this.$session.get('token')+'/'+value).then((result2) => {
              // console.log(result2.data)
              if(this.user != 'poonsak.ngk') {
                // console.log(result2.data[0].newaxis)
                this.sid.push(element.serial_id)
                this.sensordetail.push({name: element.name,data:result2.data[0].newaxis,sid: element.serial_id})
                this.sensorlist.push(result2.data[0].newaxis)
              }else{
                result2.data[0].axis.forEach((element,i) => {
                  result2.data[0].axis[i] = JSON.parse(result2.data[0].axis[i])
                });
                this.sensorlist.push(result2.data[0].axis)
                this.active = true
                jsonel = JSON.parse(element.lastdata)
                // console.log(jsonel)
                Object.keys(jsonel).forEach(rack => {
                  this.sensorlist.forEach((sensor,j) => {
                    sensor.forEach((element,i) => {
                      if(rack == element.rack) {
                        this.sensorlist[j][i].value = jsonel[rack]
                      }
                    }); 
                  });
                })
              }
            })
          });
          console.log(this.sensordetail)
          this.sensordetail.forEach((element,i) => {
            console.log(element)
            delete this.sensordetail[i].data.x
            delete this.sensordetail[i].data.y
            delete this.sensordetail[i].data.h
          });
          this.ddactive = true
        }else{
          // console.log('Not Found!')
        }
      })
      }
    },
    loadsensor(value) {
      this.width = window.innerWidth
      this.height = window.innerHeight
      var jsonel = ''
      this.sensordetail = []
      this.sensorlist = []
      this.$http.get(this.$url+'sensorid/'+this.$session.get('token')).then((result) => {
        // console.log(result.data)
        if(result.data) {
          result.data.forEach((element,i) => {
            if(this.user != 'poonsak.ngk') {
              this.$http.get(this.$url+'sensorpos/'+element.serial_id+'/'+this.$session.get('token')+'/'+value).then((result2) => {
                // console.log(result2.data)
                this.sensordetail.push({name: element.name,data:result2.data[0].newaxis,sid: element.serial_id})
                this.sid.push(element.serial_id)
                this.sensorlist.push(result2.data[0].newaxis)
                // console.log(this.sensorlist)
              })
            }else{
              this.$http.get(this.$url+'sensorpos/000001').then((result2) => {
                // console.log(result2.data)
                result2.data[0].axis.forEach((element,i) => {
                  result2.data[0].axis[i] = JSON.parse(result2.data[0].axis[i])
                });
                this.sensorlist.push(result2.data[0].axis)
                jsonel = JSON.parse(element.lastdata)
                // console.log(jsonel)
                Object.keys(jsonel).forEach(rack => {
                  this.sensorlist.forEach((sensor,j) => {
                    sensor.forEach((element,i) => {
                      if(rack == element.rack) {
                        this.sensorlist[j][i].value = jsonel[rack]
                      }
                    }); 
                  });
                })
                // console.log(this.sensorlist)
              })
            }
          });
          this.sensordetail.forEach(element => {
            console.log(element)
            delete this.sensordetail[i].data.x
            delete this.sensordetail[i].data.y
            delete this.sensordetail[i].data.h
          });
          this.ddactive2 = true
        }else{
          // console.log('Not Found!')
        }
      })
    },
    savesensor(value) {
      var check = true;
      // console.log(this.sid)
      if (this.user == "poonsak.ngk") {
        this.$http
          .post(this.$url + "sensorpos", {
            sid: this.sid[0],
            axis: this.sensorlist,
            username: this.$session.get("username"),
          })
          .then((result) => {
            if (result) {
              this.$vs.notify({
                title: "Update Map",
                text: "Successful!",
                color: "success",
                position: "top-center",
                icon: "check",
              });
            }
          })
          .catch((err) => {
            this.$vs.notify({
              title: "Update Map",
              text: "Failed!",
              color: "danger",
              position: "top-center",
              icon: "check",
            });
          });
      }else{
        console.log(this.sid,this.sensorlist)
        this.sensorlist.forEach((element,i) => {
          // console.log(this.sid[i],this.sensorlist[i],value.toString())
          this.$http
            .post(this.$url + "sensorpos2", {
              sid: this.sid[i],
              axis: this.sensorlist[i],
              mapid: value.toString(),
              username: this.$session.get("username"),
            })
            .catch(() => {
              check = false;
            });
        });
        setTimeout(() => {
          if (check) {
            this.$vs.notify({
              title: "Update Map",
              text: "Successful!",
              color: "success",
              position: "top-center",
              icon: "check",
            });
            // location.reload()
            this.modalShow = false
          }else{
            this.$vs.notify({
              title: "Update Map",
              text: "Failed!",
              color: "danger",
              position: "top-center",
              icon: "check",
            });
          }
        }, 100);
      }
    },
    FileSelect(event) {
      const file = this.$refs.file.files[0];
      this.file = file;
      // console.log(this.file);
    },
    async Upload() {
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("mapid", this.itemid);
      // console.log(formData);
      try {
        await this.$http
          .post(this.$url + "upload", formData)
          .then(() => {
            this.$vs.notify({
              color: "success",
              title: "Upload Success",
              text: "Upload image complete!",
              position: "top-center",
            });
            setTimeout(() => {
              location.reload();
            }, 200);
          })
          .catch((err) => {
            this.$vs.notify({
              color: "danger",
              title: "Upload Fail",
              text: "There is something wrong with the upload system",
              position: "top-center",
            });
          });
      } catch (err) {
        // console.log(err);
      }
    },
    successUpload() {
      // console.log(this.file)
    },
  },
  mounted() {
    this.$http
      .get(this.$url + "sensorposlist/" + this.$session.get("token"))
      .then((result) => {
        this.imsensorlist = result.data;
        // console.log(this.imsensorlist)
      });
    this.$http
      .get(this.$url + "usermap/" + this.$session.get("token"))
      .then((result) => {
        this.maplist = result.data;
        // console.log(this.maplist)
      });
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.user = this.$session.get("username");
    this.draggableValue.handle = this.$refs[this.handleId];
    this.$http.get(this.$url + "map").then((result) => {
      this.mapimgdata = result.data;
      // console.log(this.mapimgdata)
    });
  },
};
</script>

<style scoped>
#wrapper {
  display: flex;
  height: auto;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: center;
}
.card {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 20px;
  width: 200px;
  height: 160px;
  margin: 10px;
  padding: 10px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

@media only screen and (device-width: 1024px) {
  #sky {
    width: 956px;
    padding: 10px;
  }
}
@media only screen and (device-width: 768px) {
  #sky {
    display: none;
  }
  #show {
    display: show;
  }
  #responsiveSidebar {
    display: none;
  }
}
#iconMap {
  font-size: 5vh;
}

.vs-button {
  border-radius: 20px;
}
.brdbtn {
  border-radius: 20px;
}
#center {
  display: flex;
  align-items: center;
}
.rou {
  border-radius: 20px;
  height: 75%;
}
.flex-containercol {
  display: flex;
  flex-direction: col;
  /* background: #32c040; */

  /* justify-content: space-between; */
}
.flex-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  /* background: #32c040; */

  /* justify-content: space-between; */
}
.flex-item {
  width: 250px;
  height: 100px;
  cursor: move;
  /* background: #32c040; */
  margin: 10px;
}
#linecenter {
  display: flex;
  align-items: center;
}
.wrapper {
  width: 100%;
  height: 75vh;
  overflow: hidden;
  overflow-y: auto;
}
.media {
  width: 1000px;
}
.container {
  max-width: 1300px;
  margin: 0 auto;
}
.list-group-item:last-child {
  margin-bottom: 0;
  border-bottom-right-radius: 0%;
  border-bottom-left-radius: 0%;
}

.list-group-item:first-child {
  border-top-left-radius: 0%;
  border-top-right-radius: 0%;
}
.div1 {
  width: 69.23%;
  float: left;
}
#btnbackover {
  margin: 0px 5px 0px 10px;
  border-radius: 30px;
  display: flex;
  width: 90%;
  background-color: #4caf50;
  align-items: center;
}
.div2 {
  width: 23%;
  float: right;
}
.vs-upload {
  width: 10%;
}
#cardinfo {
  border-radius: 25px;
}
#btnlist {
  border: none;
}
#btnlist:hover {
  background: #effaf0;
  border-color: rgb(255, 255, 255);
}
.bts {
  width: 70px;
  border-radius: 20px;
}
#btnlist:focus {
  background: #effaf0;
  border-left: 5px solid #32c040;
  color: #32c040;
}
.div.list-group:target {
  background: #effaf0;
  border-left: 5px solid #32c040;
  color: #32c040;
}
.itemactive {
  background: #effaf0;
  border-right: 10px solid #32c040;
  color: #32c040;
}
#btnlist:visited {
  background: #effaf0;
  border-left: 5px solid #32c040;
  color: #32c040;
}
.button:target {
  background-color: red;
}
#mapl {
  font-weight: normal;
  color: #32c040;
}
.vuesax-app-is-ltr .con-vs-dialog .vs-dialog .footer .button {
  margin-left: 0;
  border-radius: 17px;
  margin-bottom: 4px;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
#sensorl {
  border-radius: 10px;
  cursor: move;
  width: 100%;
}
#datatext {
  font-size: smaller;
}
.vs-tooltip .vs-tooltip-top .vs-tooltip-dark {
  width: 600px;
}
#container {
  display: block;
}
@media only screen and (orientation: portrait) {
  #container {
    height: 100vw;
    -webkit-transform: rotate(90deg);
    -moz-transform: rotate(90deg);
    -o-transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    transform: rotate(90deg);
  }
}
@media only screen and (orientation: landscape) {
  #container {
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    transform: rotate(0deg);
  }
}
</style>
